import {TargetBlank} from '@wandb/weave/common/util/links';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Input} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const CTAInput = styled(Input)`
  padding: 16px;
`;

export const CTAContainer = styled(TargetBlank)`
  display: flex;
  justify-content: center;
  cursor: default;
`;
